import { useQuery } from '@tanstack/react-query';
import { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { api } from '../api.js';
import { useAppStore } from '../store.js';

export function CardArrivalNotice() {
  const userId = useAppStore((state) => state.session?.user.internalId);
  const location = useLocation();
  const visible = ['/', '/path', '/cards', '/store', '/leaders'].includes(location.pathname);
  const [notice, setNotice] = useState<{ userId: string; count: number } | null>(null);
  const query = useQuery({
    queryKey: ['reward-cards', 'count'],
    queryFn: api.rewardCardCount,
    enabled: !!userId && visible,
    staleTime: 15000,
    refetchInterval: visible ? 30000 : false,
  });
  const { refetch } = query;
  useEffect(() => {
    if (userId && visible) void refetch();
  }, [userId, visible, location.pathname, refetch]);
  useEffect(() => {
    if (!userId || query.data?.issuedCount === undefined) return;
    if (location.pathname === '/cards') setNotice(null);
    const key = `bb:issued-cards:${userId}`;
    try {
      const saved = localStorage.getItem(key);
      const previous = saved === null ? null : Number(saved);
      const current = query.data.issuedCount;
      if (
        location.pathname !== '/cards' &&
        previous !== null &&
        Number.isFinite(previous) &&
        current > previous
      )
        setNotice({ userId, count: current - previous });
      localStorage.setItem(key, String(current));
    } catch {
      /* A blocked store must never block rewards. */
    }
  }, [userId, query.data?.issuedCount, location.pathname]);
  useEffect(() => {
    if (!notice) return;
    const timer = window.setTimeout(() => setNotice(null), 6000);
    return () => window.clearTimeout(timer);
  }, [notice]);
  if (!visible || !notice || notice.userId !== userId || location.pathname === '/cards')
    return null;
  return (
    <aside className="card-arrival" role="status">
      <span>✦ +{notice.count} в коллекцию</span>
      <Link to="/cards" onClick={() => setNotice(null)}>
        Открыть
      </Link>
      <button aria-label="Скрыть уведомление о карточках" onClick={() => setNotice(null)}>
        ×
      </button>
    </aside>
  );
}
